import React, { useState, useEffect } from 'react';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import { Col, Row, Modal, Button, Tabs, Tab } from 'react-bootstrap';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import NotifyModal from '../../components/NotifyModal/NotifyModal';
import ApiMServer from 'services/ApiMServer';
import ApiDataEngine from 'services/ApiDataEngine';
import ApiGServer from 'services/ApiGServer';
import ApiGSenha from 'services/ApiGSenha';
import Api from 'services/Api';
import { loadState, saveState } from 'utils/persistState';
import { useAppTheme } from '../../contexts/ThemeContext';

const Logs = () => {

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.logs?.read !== true) {
    window.location.replace('/home');
  }

  const [logs, setLogs] = useState([]);
  const [logsToShow, setLogsToShow] = useState([]);
  const [activeTab, setActiveTab] = useState('mserver');
  const [methodFilters, setMethodFilters] = useState([]); // métodos HTTP selecionados (normalizados)
  const [selectedLogId, setSelectedLogId] = useState(null);
  const [selectedLogsForReport, setSelectedLogsForReport] = useState([]);
  const [serverMode, setServerMode] = useState(false);
  const prevTabRef = React.useRef(activeTab);

  const normalizeMethod = (m) => (m || '').toUpperCase().trim();

  // Métodos HTTP padrão para sempre exibir
  const defaultMethods = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS', 'HEAD'];

  // Extrai métodos únicos dos logs (normalizados) + padrões
  const getAvailableMethods = () => {
    const fromLogs = logs.map(l => normalizeMethod(l.action)).filter(Boolean);
    const merged = [...defaultMethods.map(normalizeMethod), ...fromLogs];
    return Array.from(new Set(merged));
  };

  const handleMethodChange = (rawMethod) => {
    const method = normalizeMethod(rawMethod);
    setMethodFilters((prev) =>
      prev.includes(method)
        ? prev.filter((m) => m !== method)
        : [...prev, method]
    );
  };
  const [searchData, setSearchData] = useState('');
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:logs';

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);

  const currentTheme = useAppTheme();

  // Modal de detalhes
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [detailError, setDetailError] = useState('');

  // Load persisted search on mount
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist on change
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const handleAlertModalSuccess = (msg) => {
    setType({ color: "#198754", status: msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ color: "red", status: msg })
    setModalShow(true)
  }

  const getLogs = async (tab, filter = '') => {
    try {
      setLoading(true);

      // Limpa seleções apenas no load inicial ou troca de tab (sem filtro)
      if (!filter) {
        setLogs([]);
        setLogsToShow([]);
        setMethodFilters([]);
        setSelectedLogsForReport([]);
      }

      let list = [];
      if (filter) {
        const body = { filter };
        if (tab === 'mserver') {
          const { data } = await ApiMServer.post(`/api/v1/audit-logs-filter`, body);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'dataengine') {
          const { data } = await ApiDataEngine.post(`/api/v1/audit-logs-filter`, body);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'gserver') {
          const { data } = await ApiGServer.post(`/api/v1/audit-logs-filter`, body);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'gerasenha') {
          const { data } = await ApiGSenha.post(`/api/v1/audit-logs-filter`, body);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'api') {
          const { data } = await Api.post(`/api/v1/audit-logs-filter`, body);
          list = Array.isArray(data) ? data : (data?.logs || []);
        }
      } else {
        if (tab === 'mserver') {
          const { data } = await ApiMServer.get(`/api/v1/audit-logs`);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'dataengine') {
          const { data } = await ApiDataEngine.get(`/api/v1/audit-logs`);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'gserver') {
          const { data } = await ApiGServer.get(`/api/v1/audit-logs`);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'gerasenha') {
          const { data } = await ApiGSenha.get(`/api/v1/audit-logs`);
          list = Array.isArray(data) ? data : (data?.logs || []);
        } else if (tab === 'api') {
          const { data } = await Api.get(`/audit-logs/v1/list`);
          list = Array.isArray(data) ? data : (data?.logs || []);
        }
      }

      setLogs(list || []);
      setLogsToShow(list || []);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      handleAlertModalError('Falha ao carregar audit logs!');
    }
  };

  useEffect(() => {
    const term = (searchData || '').trim();
    const tabChanged = prevTabRef.current !== activeTab;
    prevTabRef.current = activeTab;

    if (term.length > 5) {
      setServerMode(true);
      const timer = setTimeout(() => {
        getLogs(activeTab, term);
      }, 600);
      return () => clearTimeout(timer);
    } else if (serverMode || term === '' || tabChanged) {
      setServerMode(false);
      getLogs(activeTab);
    }
  }, [searchData, activeTab]);

  const normalize = (v) => (typeof v === 'string' ? v : JSON.stringify(v || ''));
  const extractSerials = (log) => {

    const candidates = [
      log?.changes?.body?.serialnumber,
      log?.changes?.serialnumber,
    ];
    return candidates
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .filter(Boolean)
      .map(String);
  };

  const handleSearch = () => {
    let filtered = logs;
    // Filtro por método
    if (methodFilters.length > 0) {
      filtered = filtered.filter((log) => methodFilters.includes(normalizeMethod(log.action)));
    }
    // Filtro por texto
    if (searchData.trim()) {
      const term = searchData.toUpperCase();
      filtered = filtered.filter((log) => {
        try {
          const candidates = [
            log?.responsible,
            log?.action,
            log?.route,
            log?.createdAt,
            ...extractSerials(log),
          ].filter(Boolean).map(normalize);
          const quickHit = candidates.some((c) => c.toUpperCase().includes(term));
          if (quickHit) return true;
          const full = normalize(log).toUpperCase();
          return full.includes(term);
        } catch (_) {
          return false;
        }
      });
    }
    setLogsToShow(filtered);
  };

  // Auto-apply quando logs, busca ou filtros mudam
  useEffect(() => {
    handleSearch();
  }, [logs, searchData, methodFilters]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  const handleClick = () => { };

  const handleSelectLog = async (id) => {
    if (!id) return;
    setSelectedLogId(id);
    setDetailError('');
    setDetailLoading(true);
    setDetailData(null);
    setDetailOpen(true);
    try {
      let payload;
      if (activeTab === 'mserver') {
        const { data } = await ApiMServer.get(`/api/v1/audit-logs/${id}`);
        payload = data?.log || data;
      } else if (activeTab === 'dataengine') {
        const { data } = await ApiDataEngine.get(`/api/v1/audit-logs/${id}`);
        payload = data?.log || data;
      } else if (activeTab === 'gserver') {
        const { data } = await ApiGServer.get(`/api/v1/audit-logs/${id}`);
        payload = data?.log || data;
      } else if (activeTab === 'gerasenha') {
        const { data } = await ApiGSenha.get(`/api/v1/audit-logs/${id}`);
        payload = data?.log || data;
      } else {
        // Fallback para a API nova caso não haja uma rota de /:id mapeada
        payload = logs.find(l => l._id === id);
        try {
          const { data } = await Api.get(`/audit-logs/v1/list/${id}`);
          if (data) payload = data?.log || data;
        } catch (err) {
          console.log("Fallback usando os logs já em tela", err);
        }
      }
      setDetailData(payload);
    } catch (e) {
      console.error(e);
      setDetailError('Falha ao carregar detalhes');
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCloseDetail = () => {
    setDetailOpen(false);
    setDetailData(null);
    setDetailError('');
  };

  const handleToggleLogSelection = (logId) => {
    setSelectedLogsForReport(prev => {
      if (prev.includes(logId)) {
        return prev.filter(id => id !== logId);
      } else {
        return [...prev, logId];
      }
    });
  };

  const handleToggleAllLogs = (logs) => {
    if (selectedLogsForReport.length === logs.length) {
      setSelectedLogsForReport([]);
    } else {
      setSelectedLogsForReport(logs.map(log => log._id));
    }
  };

  const handleDownloadReport = () => {
    const selectedLogs = logs.filter(log => selectedLogsForReport.includes(log._id));

    // Gerar CSV
    const headers = ['Data/Hora', 'Responsável', 'Ação', 'Rota', 'Detalhes'];
    const csvRows = [headers.join(',')];

    selectedLogs.forEach(log => {
      const row = [
        log.createdAt || '',
        log.responsible || '',
        log.action || '',
        log.route || '',
        JSON.stringify(log.changes || {}).replace(/"/g, '""')
      ];
      csvRows.push(row.map(field => `"${field}"`).join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `logs_report_${new Date().toISOString().slice(0, 10)}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    handleAlertModalSuccess(`Relatório gerado com ${selectedLogs.length} registro(s)!`);
  };

  return (
    <Page className="p-3" title="Logs">

      <Header page={'Logs'} />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
        variant={currentTheme === 'dark' ? 'pills' : 'tabs'}
      >
        <Tab eventKey="mserver" title="Servidor Motomco" />
        <Tab eventKey="dataengine" title="Data Engine" />
        <Tab eventKey="api" title="Monitoramento" />
        <Tab eventKey="gserver" title="Global Server" />
        <Tab eventKey="gerasenha" title="Gera Senha" />
      </Tabs>

      <Row className="align-items-center g-2 mb-2">
        <Col xs={12}>
          {/* Filtros de método HTTP */}

          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />

          <div style={{ marginBottom: 8, display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            {/* Botão selecionar/limpar todos */}
            {getAvailableMethods().length > 1 && (
              <label style={{ marginRight: 16, fontWeight: 600 }}>
                <input
                  type="checkbox"
                  checked={methodFilters.length === getAvailableMethods().length}
                  onChange={() => {
                    if (methodFilters.length === getAvailableMethods().length) {
                      setMethodFilters([]);
                    } else {
                      setMethodFilters(getAvailableMethods());
                    }
                  }}
                  style={{ marginRight: 4 }}
                />
                Todos
              </label>
            )}
            {getAvailableMethods().map((method) => (
              <label key={method} style={{ marginRight: 12, fontWeight: 500 }}>
                <input
                  type="checkbox"
                  checked={methodFilters.includes(method)}
                  onChange={() => handleMethodChange(method)}
                  style={{ marginRight: 4 }}
                />
                {method}
              </label>
            ))}

            <Button
              variant="success"
              size="sm"
              disabled={selectedLogsForReport.length === 0}
              onClick={handleDownloadReport}
              style={{ marginLeft: 'auto' }}
            >
              Baixar Relatório ({selectedLogsForReport.length})
            </Button>
          </div>
        </Col>
      </Row>

      {logsToShow && (
        <Results
          user={user}
          data={logsToShow}
          currentTheme={currentTheme}
          onSelect={handleSelectLog}
          selectedLogId={selectedLogId}
          selectedLogsForReport={selectedLogsForReport}
          onToggleLogSelection={handleToggleLogSelection}
          onToggleAllLogs={handleToggleAllLogs}
        />
      )}

      <Modal
        show={detailOpen}
        onHide={handleCloseDetail}
        size="lg"
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header closeButton className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Modal.Title>Detalhes do Log</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'} style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {detailLoading && <Reload />}
          {!detailLoading && detailError && (
            <div className="text-danger small">{detailError}</div>
          )}
          {!detailLoading && !detailError && detailData && (
            <pre style={{ fontSize: '0.75rem' }}>
              {JSON.stringify(detailData, null, 2)}
            </pre>
          )}
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleCloseDetail}>Fechar</Button>
        </Modal.Footer>
      </Modal>

    </Page>
  );
};

export default Logs;
